import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { WriteGuard } from "@/components/billing/write-guard";
import { useOrganization, useRenameOrganization } from "@/hooks/queries/use-organization";

/**
 * Organization name, editable by org admins (the server enforces it: the
 * members screen that hosts this is admin-only).
 */
export function OrganizationNameSetting() {
  const { data: org } = useOrganization();
  const rename = useRenameOrganization();
  const [name, setName] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (org) setName(org.name);
  }, [org]);

  if (!org) return null;
  const changed = name.trim() !== "" && name.trim() !== org.name;

  return (
    <div>
      <h2 className="mb-3 text-base font-medium">Organization name</h2>
      <form
        className="flex flex-col gap-2 sm:flex-row sm:items-center"
        onSubmit={(e) => {
          e.preventDefault();
          if (!changed) return;
          rename.mutate(name.trim(), {
            onSuccess: () => {
              setSaved(true);
              setTimeout(() => {
                setSaved(false);
              }, 2000);
            },
          });
        }}
      >
        <Input
          aria-label="Organization name"
          className="sm:max-w-sm"
          maxLength={100}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <WriteGuard>
          <Button type="submit" size="sm" disabled={!changed || rename.isPending}>
            {rename.isPending ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : saved ? (
              <>
                <Check className="mr-1 h-4 w-4" /> Saved
              </>
            ) : (
              "Save"
            )}
          </Button>
        </WriteGuard>
      </form>
      {rename.error && (
        <p className="mt-2 text-sm text-destructive" role="alert">
          {rename.error instanceof Error ? rename.error.message : "Could not rename the organization."}
        </p>
      )}
    </div>
  );
}
